import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import '../css/modalCodigo.css';
import { handleError, toastError, toastInfoUniqueInfinite, toastSuccess } from '../funciones.js';

function ModalCodigo(props) {

    const [mail, setMail] = useState('');

    function obtenerCodigo() {
        var mail;
        if (localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA) !== null)
            mail = localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA);
        else
            mail = document.getElementById("mailRecuperar").value;

        if (mail !== "") {
            setMail(mail);
            const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 300000));
            const params = {
                params: {
                    mail: mail
                }
            }
            toast.promise(resolveAfter3Sec, { pending: "Enviando, aguarde un instante" })
            axios.post(process.env.REACT_APP_URL + (props.isRegistro === 1 ? "enviarMailRegistro" : "enviarMailRecuperoContrasenia"), null, params)
                .then(function (resp) {
                    toast.dismiss();
                    toastSuccess("Se ha enviado el código");
                    toastInfoUniqueInfinite("Si no recibió el mail, revise la carpeta de Spam")
                    const contador = document.getElementById("contador");
                    const botonEnviarCodigo = document.getElementById("enviarCodigo")
                    var n = 300;
                    botonEnviarCodigo.innerText = "Reenviar código";
                    botonEnviarCodigo.classList.add("pe-none");
                    var intervalID = window.setInterval(function () {
                        if (n === 0) {
                            contador.innerText = "El Tiempo de validez se agotó, pida un nuevo código";
                            window.clearInterval(intervalID);
                            botonEnviarCodigo.classList.remove("pe-none");
                        }
                        else {
                            if (n > 60) {
                                if (n % 60 < 10)
                                    contador.innerHTML = "Tiempo de validez del código: " + Math.floor(n / 60) + ":0" + n % 60;
                                else
                                    contador.innerHTML = "Tiempo de validez del código: " + Math.floor(n / 60) + ":" + n % 60;
                            }
                            else
                                contador.innerHTML = "Tiempo de validez del código: " + n + " segundos";
                        }

                        n--;

                    }, 1000);
                })
                .catch(function (error) {
                    toast.dismiss();
                    toastError(handleError(error));
                });
        }
        else {
            toastError("Ingrese un mail");
        }
    }

    function compararCodigos() {
        var mail;
        if (localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA) !== null)
            mail = localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA);
        else
            mail = document.getElementById("mailRecuperar").value;
        if (mail !== "") {
            setMail(mail);

            var codigoIngreso = "";
            for (var i = 1; i < 7; i++) {
                codigoIngreso += document.getElementById("codigoIngreso" + i).value;
            }
            const params = {
                params: {
                    mail: mail,
                    codigo: codigoIngreso
                }
            } 
            axios.post(process.env.REACT_APP_URL + "enviarCodigoVerificar", null, params)
                .then(function (resp) {
                    //if (parseInt(codigoIngreso) === 687423) {
                    if (props.isRegistro === 1) {
                        //localStorage.removeItem(process.env.REACT_APP_MAIL_EMPRESA); 
                        localStorage.setItem(process.env.REACT_APP_CODIGO_APROBADO, 1);
                        toastSuccess("Mail verificado, continúe");
                        document.getElementById("btnSiguiente").click();
                    }
                    else {
                        if (parseInt(localStorage.getItem(process.env.REACT_APP_DESDE_PERFIL)) === 1) {
                            localStorage.setItem(process.env.REACT_APP_DESDE_PERFIL, 2);
                        }
                        document.getElementById('abrirModalRecuperar').click();
                        toastSuccess("Código correcto");

                    }
                    document.getElementById('cerrarModalCodigo').click();
                    //}
                    //document.getElementById('ModalRecuperar').classList.add('mostrarModal');

                })
                .catch(function (error) {
                    toastError(handleError(error));
                });
        } else {
            toastError("Ingrese un mail");
        }
    }

    function cambiarFocusOnInput(idTextActual) {
        const valorText = document.getElementById("codigoIngreso" + idTextActual).value.toString();
        document.getElementById("codigoIngreso" + idTextActual).value = valorText;
        if (valorText.length === 6) {
            for (var x = 0; x <= valorText.length; x++) {
                if (x <= 5) {
                    document.getElementById("codigoIngreso" + (x + 1)).value = valorText.charAt(x);
                }
            }
        } else if (valorText.length > 6) {
            for (var x = 1; x <= valorText.length; x++) {
                if (x <= 6) {
                    document.getElementById("codigoIngreso" + (x)).value = valorText.charAt(x);
                }
            }
        }
        if (valorText.length !== 6 && valorText.length !== 7) {
            document.getElementById("codigoIngreso" + (idTextActual)).value = valorText.charAt(valorText.length - 1);
        }
    }

    function cambiarFocusOnPress(event) {

        var idTextActual = parseInt(event.target.id.substr(-1));
        const valorText = document.getElementById("codigoIngreso" + idTextActual).value;

        if (valorText != "") {
            if (event.keyCode !== 8) {
                if (event.keyCode === 13 || event.keyCode === 108)
                    document.getElementById('botonIngresarCodigo').click();
                else if (event.keyCode !== 9 && event.keyCode !== 189 && event.keyCode !== 109 && event.keyCode !== 110
                    && event.keyCode !== 190 && event.keyCode !== 107 && event.keyCode !== 187 && event.keyCode !== 69)
                    idTextActual += 1;
            }
        }
        else {
            if (event.keyCode === 8) {
                idTextActual -= 1;
            }
        }
        if (idTextActual !== 0 && idTextActual !== 7) {
            /*if(document.getElementById("codigoIngreso" + idTextActual).value !== "")
                document.getElementById("codigoIngreso" + idTextActual).value = ""*/
            document.getElementById("codigoIngreso" + idTextActual).focus();
        }
    }
    function cerrarModal() {
        if (parseInt(localStorage.getItem(process.env.REACT_APP_DESDE_PERFIL)) === 1) {
            localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL);
            document.getElementById('abrirPerfil').click();
        }

    }

    return (
        <>
            <div class="modal fade" id="modalCodigo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content padModalCodigo rounded-4">
                        <div class="modal-header">
                            <h5 class="letraTituloPerfil mb-0" id="exampleModalLongTitle">Validación por mail</h5>
                            <button type="button" class="btn-close ms-auto" id="cerrarModalCodigo" aria-label="Close"
                                data-bs-dismiss="modal" onClick={props.isRegistro !== 1 ? cerrarModal : void (0)} ></button>
                        </div>
                        <div class="modal-body">
                            <label for={props.id} class="form-label letraDatos text-center">Presione "Enviar Código al Mail" e ingrese el código recibido</label>

                            <div className='d-none' data-bs-toggle="modal" data-bs-target="#modalCodigo" id="abrirModalCodigo"></div>
                            <div class="container">
                                {!localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA) ?
                                    <div id="inputMailRecuperar">
                                        <p className='letraModalInicio'>Dirección de mail</p>
                                        <input type="text" class="form-control" id="mailRecuperar" placeholder="" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                    </div>
                                    :
                                    <></>
                                }
                                <div className='row text-center'>
                                    <div className='col'>
                                        {/*<button class="btn colorPrincipal text-white bold-botones my-4" id='enviarCodigo' onClick={obtenerCodigo}>Enviar Código al Mail</button>*/}
                                    </div></div>
                                <div class="row d-flex justify-content-center mt-4">
                                    <input type="number" onInput={() => cambiarFocusOnInput(1)} onKeyDown={cambiarFocusOnPress} class="form-control digitoCodigo m-2" id="codigoIngreso1" placeholder="-" />
                                    <input type="number" onInput={() => cambiarFocusOnInput(2)} onKeyDown={cambiarFocusOnPress} class="form-control digitoCodigo m-2" id="codigoIngreso2" placeholder="-" />
                                    <input type="number" onInput={() => cambiarFocusOnInput(3)} onKeyDown={cambiarFocusOnPress} class="form-control digitoCodigo m-2" id="codigoIngreso3" placeholder="-" />
                                    <input type="number" onInput={() => cambiarFocusOnInput(4)} onKeyDown={cambiarFocusOnPress} class="form-control digitoCodigo m-2" id="codigoIngreso4" placeholder="-" />
                                    <input type="number" onInput={() => cambiarFocusOnInput(5)} onKeyDown={cambiarFocusOnPress} class="form-control digitoCodigo m-2" id="codigoIngreso5" placeholder="-" />
                                    <input type="number" onInput={() => cambiarFocusOnInput(6)} onKeyDown={cambiarFocusOnPress} class="form-control digitoCodigo m-2" id="codigoIngreso6" placeholder="-" />
                                </div>
                            </div>
                            <div id="contador" class="  my-3"></div>
                        </div>
                        <div class="modal-footer">

                            <button class="btn  colorAzulHover" id='enviarCodigo' onClick={obtenerCodigo}>Enviar Código al Mail</button>
                            <button id="botonIngresarCodigo" class="btn colorPrincipal text-white bold-botones"
                                onClick={compararCodigos}>{props.isRegistro ? 'Siguiente' : 'Ingresar Código'}</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}


export default ModalCodigo;
